import React, { useEffect } from 'react';
import { Page, Spinner } from 'seagull';
import { useStore, useStoreActions } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { CreateProposalButton } from "../../components/CreateProposalButton";
import BusinessOnboardingWidget from "./BusinessOnboardingWidget/BusinessOnboardingWidget";
import AgreementPipelineWidget from "./AgreementPipelineWidget/AgreementPipelineWidget";
import InvoicesWidget from "./InvoicesWidget/InvoicesWidget";
import MonthlyEarningsWidget from "./MonthlyEarningsWidget/MonthlyEarningsWidget";
import styles from "./VendorDashboard.module.scss";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import HistoricAgreementStatsWidget from "./HistoricAgreementStatsWidget/HistoricAgreementStatsWidget";
import PayoutsSummaryWidget from "./PayoutsSummaryWidget/PayoutsSummaryWidget";
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import InvoicesDigestWidget from "./InvoicesDigestWidget/InvoicesDigestWidget";
import SalesWidget from "./SalesWidget/SalesWidget";
import RevenueWidget from "./RevenueWidget/RevenueWidget";
export default function VendorDashboard() {
  const hasBusiness = useStore(selectors.user.hasBusiness);
  const user1stName = useStore(selectors.user.firstName) || '';
  const isMemberUser = useStore(selectors.user.isMemberUser);
  const initialData = useStore(s => s.personaKYBStatus.data);
  const {
    fetchPersonaKYBStatus
  } = useStoreActions();
  const {
    HISTORIC_AGREEMENT_STATS,
    PAYOUTS_SUMMARY,
    REVENUE_WIDGET,
    INVOICES_DIGEST
  } = useFeatureFlags();
  useEffect(() => {
    document.title = 'My Dashboard';
  }, []);
  return /*#__PURE__*/React.createElement(Page, {
    "data-testid": "vendor-dashboard",
    header: "Hi ".concat(user1stName, "!"),
    actions: /*#__PURE__*/React.createElement(CreateProposalButton, null),
    minWidth: "1090px"
  }, hasBusiness ? /*#__PURE__*/React.createElement(RestfulWrapper, {
    initialData: initialData,
    fetch: fetchPersonaKYBStatus,
    renderChild: () => /*#__PURE__*/React.createElement("div", {
      className: styles.widgets,
      "data-testid": "vendor-dashboard-widgets"
    }, !isMemberUser && /*#__PURE__*/React.createElement(BusinessOnboardingWidget, {
      className: styles.fullWidth
    }), INVOICES_DIGEST ? /*#__PURE__*/React.createElement(InvoicesDigestWidget, null) : /*#__PURE__*/React.createElement(InvoicesWidget, null), HISTORIC_AGREEMENT_STATS ? /*#__PURE__*/React.createElement(HistoricAgreementStatsWidget, null) : /*#__PURE__*/React.createElement(AgreementPipelineWidget, null), /*#__PURE__*/React.createElement(PayoutsSummaryWidget, null), REVENUE_WIDGET && /*#__PURE__*/React.createElement(RevenueWidget, null), /*#__PURE__*/React.createElement(SalesWidget, null), !isMemberUser && !PAYOUTS_SUMMARY && /*#__PURE__*/React.createElement("div", {
      className: styles.fullWidth
    }, /*#__PURE__*/React.createElement(MonthlyEarningsWidget, null))),
    renderLoader: () => /*#__PURE__*/React.createElement(Spinner, {
      "data-testid": "vendor-dashboard-loading",
      centeredInBox: true
    })
  }) : /*#__PURE__*/React.createElement("div", {
    "data-testid": "vendor-dashboard-no-business"
  }));
}